import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUser, fetchuserdetails, DoUpdateDetails, SendOTP, verifyOTP, verifyPAN } from "./authSlice";
import { DateInput } from "@mantine/dates";
import { Calendar, ShieldCheck } from "lucide-react";
import nationality from "../../data/countrycode.json";
import { toast } from "react-hot-toast";
import { FetchAllCountry, FetchCountry, FetchState, FetchAllState, FetchCity, FetchAllCity } from "../users/usersSlice";
export default function ProfileUpdateForm() {
  const {
    detailsstatus,
    details,
    UpdateUserData,
    UpdateUserstatus,
    SendOTPData,
    SendOTPstatus,
    VerifyOTPstatus,
    VerifyData,
    VerifyPANData,
    VerifyPANstatus,
  } = useSelector((state) => state.auth);
  const user = useSelector(selectCurrentUser);

  const CountryData = useSelector(FetchAllCountry);
  const StateData = useSelector(FetchAllState);
  const CitiesData = useSelector(FetchAllCity);
  const [UserData, setUserData] = useState([]);
  const dispatch = useDispatch();
  const [response, setResponse] = useState(user);
  const [formData, setFormData] = useState({
    name: UserData?.name || "",
    email: UserData?.email || "",
    mobile: UserData?.mobile || "",
    title: UserData?.user?.title || "",
    fname: UserData?.user?.fname || "",
    lname: UserData?.user?.lname || "",
    countrycode: UserData?.user?.countrycode || "91",
    panno: UserData?.user?.panno || "",
    passno: UserData?.user?.passno || "",
    dob: null,
    passisse: null,
    passexp: null,
    address: "",
    address1: "",
    agencyName: "",
    companyemail: "",
    companymobile: "",
    pincode: "",
    tax_number: "",
    companyLogo: null,
    mst_city_id: UserData?.user?.details?.mst_city_id,
    mst_country_id: UserData?.user?.details?.mst_country_id || "1",
    mst_state_id: UserData?.user?.details?.mst_state_id,
    IsMobileVerify: false,
    IsPanVerify: false,
  });

  useEffect(() => {
    dispatch(fetchuserdetails());
    dispatch(FetchCountry());
  }, [dispatch]);

  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(response));
  }, [response]);
  useEffect(() => {
    if (detailsstatus === "success") {
      setResponse((prev) => ({
        ...prev,
        ...details, // ✅ only overwrites UserData, status, httpStatus, message
      }));

      setUserData(details.UserData);
      setFormData({
        name: details.UserData?.name || "",
        email: details.UserData?.email || "",
        mobile: details.UserData?.mobile || "",
        title: details.UserData?.user?.title || "",
        fname: details.UserData?.user?.fname || "",
        lname: details.UserData?.user?.lname || "",
        countrycode: details.UserData?.user?.countrycode || "91",
        panno: details.UserData?.user?.panno || "",
        passno: details.UserData?.user?.passno || "",
        passnational: details.UserData?.user?.passnational || "",
        dob: details.UserData?.user?.dateofbirth || null,
        passisse: details.UserData?.user?.passisse || null,
        passexp: details.UserData?.user?.passexp || null,
        address: details.UserData?.user?.details?.address || "",
        address1: details.UserData?.user?.details?.address1 || "",
        agencyName: details.UserData?.user?.details?.agencyName || "",
        companyemail: details.UserData?.user?.details?.email || "",
        companymobile: details.UserData?.user?.details?.mobile || "",
        pincode: details.UserData?.user?.details?.pincode || "",
        tax_number: details.UserData?.user?.details?.tax_number || "",
        companyLogo: details.UserData?.user?.details?.logo || null,
        mst_city_id: details?.UserData?.user?.mst_city_id || "1",
        mst_country_id: details?.UserData?.user?.mst_country_id || "1",
        mst_state_id: details?.UserData?.user?.mst_state_id || "1",
        IsMobileVerify: details.UserData?.user?.details?.IsMobileVerify || 0,
        IsPanVerify: details.UserData?.user?.details?.IsPanVerify || 0,
        country: details.UserData?.user?.details?.country || "India",
        state: details.UserData?.user?.details?.state || 0,
        city: details.UserData?.user?.details?.city || 0,
      });
    }
  }, [detailsstatus, details]);

  const handleChange = (eOrName) => {
    const hasTarget = eOrName && typeof eOrName === "object" && "target" in eOrName;
    const name = hasTarget ? eOrName.target?.name : undefined;
    const type = hasTarget ? eOrName.target?.type : undefined;
    const value = hasTarget ? eOrName.target?.value : undefined;
    const files = hasTarget ? eOrName.target?.files : undefined;

    if (type === "file" && files && files.length > 0) {
      const file = files[0];
      const reader = new FileReader();

      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          [name]: file,
          [`${name}_preview`]: reader.result,
          [`${name}_path`]: reader.result,
          [`${name}_name`]: file.name,
          [`${name}_size`]: file.size,
          [`${name}_type`]: file.type,
        }));
      };

      reader.readAsDataURL(file);
    } else if (typeof eOrName === "string") {
      setFormData((prev) => ({
        ...prev,
        [eOrName]: value,
      }));
    } else if (hasTarget) {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const fetchStates = () => {
    const Body = {
      countryid: formData.mst_country_id,
      name: formData.country,
    };
    dispatch(FetchState(Body));
  };

  const fetchCities = () => {
    let selectedstate = null;
    if (formData.state && StateData?.result) {
      selectedstate = StateData.result.find((item) => item.name === formData.state);
    }

    if (!selectedstate && formData.mst_state_id && StateData?.result) {
      selectedstate = StateData.result.find((item) => item.id == formData.mst_state_id);
    }

    if (selectedstate) {
      const Body = {
        countryid: formData.mst_country_id,
        stateid: selectedstate.id,
        name: selectedstate.name,
      };
      dispatch(FetchCity(Body));
    }
  };

  useEffect(() => {
    if (formData.country && formData.mst_country_id && formData.mst_country_id !== "0") {
      setTimeout(() => {
        fetchStates();
      }, 300);
    }
  }, [formData.country, formData.mst_country_id]);

  useEffect(() => {
    if (StateData?.result?.length > 0) {
      if (formData.state && formData.mst_state_id && formData.mst_state_id !== "0") {
        setTimeout(() => {
          fetchCities();
        }, 500);
      }
    }
  }, [StateData]);
  useEffect(() => {
    if (formData.state && formData.mst_state_id && StateData?.result?.length > 0) {
      setTimeout(() => {
        fetchCities();
      }, 400);
    }
  }, [formData.state, formData.mst_state_id, formData.mst_country_id]);

  useEffect(() => {
    if (UpdateUserstatus === "success" && UpdateUserData?.status?.success === true) {
      toast.success(UpdateUserData?.message, { autoClose: 2000 });
      dispatch(fetchuserdetails());
    } else if (UpdateUserstatus === "success" && UpdateUserData?.status?.success === false) {
      toast.error(UpdateUserData?.message, { autoClose: 2000 });
    }
  }, [UpdateUserstatus, UpdateUserData]);
  const handleProceed = async (e) => {
    e.preventDefault();
    const submitFormData = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "image" && formData[key] instanceof File) {
        submitFormData.append("image", formData[key]);
      } else if (
        !key.endsWith("_preview") &&
        !key.endsWith("_path") &&
        !key.endsWith("_name") &&
        !key.endsWith("_size") &&
        !key.endsWith("_type")
      ) {
        submitFormData.append(key, formData[key]);
      }
    });
    console.log("Final FormData entries:",submitFormData);
    for (let [key, value] of submitFormData.entries()) {
      console.log(`${key}:`, value);
    }
    // return false;
    dispatch(DoUpdateDetails(submitFormData));
  };
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [panSent, setPANSent] = useState(false);

  const handleSendOtp = () => {
    const OTPRequest = {
      phone: UserData?.mobile,
      purpose: "Mobile number verify OTP",
    };
    dispatch(SendOTP(OTPRequest));
  };

  useEffect(() => {
    if (SendOTPstatus === "success" && SendOTPData?.status?.success === true) {
      setOtpSent(true);
    } else if (SendOTPstatus === "success" && SendOTPData?.status?.success === false) {
      toast.error(SendOTPData?.message, { autoClose: 2000 });
    }
  }, [SendOTPstatus, SendOTPData]);

  useEffect(() => {
    if (VerifyOTPstatus === "success" && VerifyData?.status?.success === true) {
      toast.success(VerifyData?.message, { autoClose: 2000 });
      setOtpSent(false);
      setFormData({
        ...formData,
        ["IsMobileVerify"]: true,
      });
    } else if (VerifyOTPstatus === "success" && VerifyData?.status?.success === false) {
      toast.error(VerifyData?.message, { autoClose: 2000 });
    }
  }, [VerifyOTPstatus, VerifyData]);

  useEffect(() => {
    if (VerifyPANstatus === "success" && VerifyPANData?.status?.success === true) {
      toast.success(VerifyPANData?.message, { autoClose: 2000 });
      setFormData({
        ...formData,
        ["IsPanVerify"]: true,
      });
    } else if (VerifyPANstatus === "success" && VerifyPANData?.status?.success === false) {
      toast.error(VerifyPANData?.message, { autoClose: 2000 });
    }
  }, [VerifyPANData, VerifyPANstatus]);

  const handleVerifyOtp = () => {
    const Verify = {
      phone: UserData?.mobile,
      otp: otp,
    };
    if (otp === "") {
      toast.error("Please enter OTP", { autoClose: 2000 });
      return false;
    }
    dispatch(verifyOTP(Verify));
  };
  const handlePANVerify = () => {
    const PanVerify = {
      pan: formData?.panno,
      customer_id: UserData?.id,
    };
    if (formData.panno === "") {
      toast.error("Please enter PAN number", { autoClose: 2000 });
      return false;
    }
    dispatch(verifyPAN(PanVerify));
  };
  const handleCountryChange = (e) => {
    const name = e.target.name;
    if (name == "country") {
      const selectedCountryName = e.target.value;
      const selectedCountry = CountryData?.result?.find((item) => item.name === selectedCountryName);
      setFormData((prev) => ({
        ...prev,
        country: selectedCountryName,
        mst_country_id: selectedCountry ? selectedCountry.id : "0",
      }));
    }
    if (name == "state") {
      const selectedCountryName = e.target.value;
      const selectedCountry = StateData?.result?.find((item) => item.name === selectedCountryName);
      setFormData((prev) => ({
        ...prev,
        state: selectedCountryName,
        mst_state_id: selectedCountry ? selectedCountry.id : "0",
      }));
    }
    if (name == "city") {
      const selectedCountryName = e.target.value;
      const selectedCountry = CitiesData?.result?.find((item) => item.cityName === selectedCountryName);
      setFormData((prev) => ({
        ...prev,
        city: selectedCountryName,
        mst_city_id: selectedCountry ? selectedCountry.id : "0",
      }));
    }
  };
  return (
    <form onSubmit={handleProceed} className="mui-form">
      <div className="max-w-6xl mx-auto p-4 bg-white shadow rounded-lg mt-4">
        {detailsstatus === "pendig" && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-xl shadow-lg w-80 text-center">
              <h2 className="text-lg font-semibold mb-4">Please wait....</h2>
              <div className="mt-6 flex flex-col items-center justify-center">
                <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
              </div>
            </div>
          </div>
        )}
        <div className="flex items-start justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-800">
            {UserData?.user?.details?.onboarding_process === 100 ? "Profile Update" : "Complete Onboarding Process"}
          </h3>
          {UserData?.user?.details?.onboarding_process === 100 ? (
            <em className="text-sm text-green-500">PAN and mobile is verified</em>
          ) : (
            <em className="text-sm text-red-500">
              Your onboarding will be complete once you verify your PAN and mobile number.
            </em>
          )}
        </div>

        <hr className="border-t border-gray-200 my-3" />
        {/* Personal Details */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Title</label>
            <select
              name="title"
              value={formData.title}
              className="w-full border rounded-lg px-3 py-2"
              onChange={handleChange}
            >
              <option value="Mr">Mr</option>
              <option value="Mrs">Mrs</option>
              <option value="Ms">Ms</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">First Name</label>
            <input
              type="text"
              value={formData.fname}
              name="fname"
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
              placeholder="First Name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Last Name</label>
            <input
              type="text"
              value={formData.lname}
              name="lname"
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
              placeholder="Last Name"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Email</label>
            <input type="email" value={formData.email} className="w-full border rounded-lg px-3 py-2 " disabled />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Country Code</label>
            <select
              value={formData.countrycode}
              name="countrycode"
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
            >
              {nationality.map((item, key) => (
                <option key={item.countryid} value={item.dial_code}>
                  {item.countryname} +{item.dial_code}
                </option>
              ))}
            </select>
          </div>
          <div>
            {/* <label className="block text-sm font-medium mb-1">Mobile No.<span className="text-red-500 ml-1">*</span></label> */}
            {/* <input type="text" value={formData.mobile} className="w-full border rounded-lg px-3 py-2 bg-gray-100" disabled /> */}
            <div className="space-y-3">
              {/* Mobile number + Send OTP */}
              <div className="flex items-center gap-2">
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">
                    Mobile No.<span className="text-red-500 ml-1">*</span>
                  </label>
                  <input type="text" value={formData.mobile} className="w-full border rounded-lg px-3 py-2 " disabled />
                </div>
                {formData.IsMobileVerify === 1 || formData.IsMobileVerify === true ? (
                  <>
                    <button
                      type="button"
                      className="mt-6 bg-green-500 text-white px-4 py-2 rounded-lg shadow hover:bg-green-600"
                    >
                      <ShieldCheck />
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      type="button"
                      onClick={handleSendOtp}
                      disabled={SendOTPstatus === "pendig"}
                      className={`mt-6 bg-[#f4a406] text-white px-4 py-2 rounded-lg shadow hover:bg-yellow-600 ${SendOTPstatus === "pendig"
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-[#f4a406] hover:bg-yellow-600"
                        }`}
                    >
                      {SendOTPstatus === "pendig" ? <>Sending...</> : <>Send OTP</>}
                    </button>
                  </>
                )}
              </div>

              {/* OTP input appears after sending */}
              {otpSent && (
                <div className="flex items-center gap-2">
                  <input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    placeholder="Enter OTP"
                    className="flex-1 border rounded-lg px-3 py-2"
                  />
                  <button
                    type="button"
                    onClick={handleVerifyOtp}
                    className="bg-green-600 text-white px-4 py-2 rounded-lg shadow hover:bg-green-700"
                  >
                    Verify
                  </button>
                </div>
              )}
            </div>
          </div>
          <div>
            {/* <label className="block text-sm font-medium mb-1">PAN No.<span className="text-red-500 ml-1">*</span></label>
            <input type="text" value={formData.panno} name='panno' onChange={handleChange} className="w-full border rounded-lg px-3 py-2" placeholder="PAN No." /> */}

            <div className="space-y-3">
              {/* Mobile number + Send OTP */}
              <div className="flex items-center gap-2">
                <div className="flex-1">
                  <label className="block text-sm font-medium mb-1">
                    PAN No.<span className="text-red-500 ml-1">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.panno}
                    name="panno"
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 "
                    disabled={formData.IsPanVerify === 1 || formData.IsPanVerify === true}
                  />
                </div>
                {formData.IsPanVerify === 1 || formData.IsPanVerify === true ? (
                  <>
                    <button
                      type="button"
                      className="mt-6 bg-green-500 text-white px-4 py-2 rounded-lg shadow hover:bg-green-600"
                    >
                      <ShieldCheck />
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      type="button"
                      onClick={handlePANVerify}
                      disabled={SendOTPstatus === "pendig"}
                      className={`mt-6 bg-[#f4a406] text-white px-4 py-2 rounded-lg shadow hover:bg-yellow-600 ${SendOTPstatus === "pendig"
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-[#f4a406] hover:bg-yellow-600"
                        }`}
                    >
                      {SendOTPstatus === "pendig" ? <>Verifying...</> : <>Verify</>}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>

          <div>
            <DateInput
              label="Date of Birth"
              placeholder="dd-mm-yyyy"
              valueFormat="DD-MM-YYYY"
              maxDate={new Date()} // min date = today
              className="w-full"
              value={formData.dob}
              onChange={(date) => handleChange("dob", date)}
              rightSection={<Calendar size={18} className="text-gray-500" />} // 👈 custom calendar icon
            />
          </div>
          <div>
            <DateInput
              label="Passport Issue Date"
              placeholder="dd-mm-yyyy"
              valueFormat="DD-MM-YYYY"
              maxDate={new Date()} // min date = today
              className="w-full"
              value={formData.passisse}
              onChange={(date) => handleChange("passisse", date)}
              rightSection={<Calendar size={18} className="text-gray-500" />} // 👈 custom calendar icon
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1 :required">Passport No.</label>
            <input
              type="text"
              name="passno"
              value={formData.passno}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
              placeholder="Passport No."
            />
          </div>
          <div>
            <DateInput
              label="Passport Expiry"
              placeholder="dd-mm-yyyy"
              valueFormat="DD-MM-YYYY"
              minDate={new Date()} // min date = today
              className="w-full"
              value={formData.passexp}
              onChange={(date) => handleChange("passexp", date)}
              rightSection={<Calendar size={18} className="text-gray-500" />} // 👈 custom calendar icon
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Passport Nationality</label>
            <select
              value={formData.passnational}
              name="passnational"
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
            >
              {nationality.map((item, key) => (
                <option key={item.countryid} value={item.code}>
                  {item.countryname} - {item.code}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Communication Details */}
        <h3 className="text-lg font-semibold mt-8 mb-4">Communication Details</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Agency/Company Name</label>
            <input
              type="text"
              value={formData.agencyName}
              name="agencyName"
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
              placeholder="Agency Name"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Contact/Mobile</label>
            <input
              type="text"
              value={formData.companymobile}
              name="companymobile"
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
              placeholder="Contact No."
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Email</label>
            <input
              type="email"
              value={formData.companyemail}
              name="companyemail"
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
              placeholder="Email"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              TAX/GST Number<span className="text-red-500 ml-1">*</span>
            </label>
            <input
              type="text"
              value={formData.tax_number}
              name="tax_number"
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
              placeholder="TAX/GST No."
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              Registered Address Line 1<span className="text-red-500 ml-1">*</span>
            </label>
            <input
              type="text"
              value={formData.address}
              name="address"
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
              placeholder="Registered Address Line 1"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Registered Address Line 2</label>
            <input
              type="text"
              value={formData.address1}
              name="address1"
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
              placeholder="Registered Address Line 2"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Country</label>
            <select
              value={formData.country}
              name="country"
              onChange={handleCountryChange}
              className="w-full border rounded-lg px-3 py-2"
            >
              {CountryData &&
                CountryData?.result &&
                CountryData?.result?.map((item, key) => (
                  <option key={item.id} value={item.name}>
                    {item.name}
                  </option>
                ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">State</label>
            <select
              value={formData.state}
              name="state"
              onChange={handleCountryChange}
              className="w-full border rounded-lg px-3 py-2"
            >
              {StateData &&
                StateData?.result &&
                StateData?.result?.map((item, key) => (
                  <option key={item.id} value={item.name}>
                    {item.name}
                  </option>
                ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">City</label>
            <select
              value={formData.city}
              name="city"
              onChange={handleCountryChange}
              className="w-full border rounded-lg px-3 py-2"
            >
              {CitiesData &&
                CitiesData?.result &&
                CitiesData?.result?.map((item, key) => (
                  <option key={item.id} value={item.cityName}>
                    {item.cityName}
                  </option>
                ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">PIN Code</label>
            <input
              type="text"
              value={formData.pincode}
              name="pincode"
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2"
              placeholder="Postal Code"
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Company Logo</label>
            <input
              type="file"
              name="logo"
              className="w-full border rounded-lg px-3 py-2"
              accept="image/*"
              onChange={handleChange}
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Company Logo</label>
            <img
              src={formData.companyLogo}
              alt={formData.agencyName}
              style={{ width: "200px" }}
              className="img-fluid rounded mt-2 companylogo"
            />
          </div>
        </div>

        {/* Submit Button */}
        <div className="mt-8 text-right">
          <button type="submit" className="bg-blue-500 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-600">
            Update Profile
          </button>
        </div>
      </div>
    </form>
  );
}
